import type {
	GestureUpdateEvent,
	PanGestureChangeEventPayload,
	PanGestureHandlerEventPayload,
} from "react-native-gesture-handler";
import { SharedValue } from "react-native-reanimated";
import native from "src/constants/native";
import type { DragArea } from "./DragSelectionProvider";

export const updateDragArea = (
	dimHeight: number,
	dragArea: SharedValue<DragArea>,
	event: GestureUpdateEvent<PanGestureHandlerEventPayload & PanGestureChangeEventPayload>,
	scrollOffset: SharedValue<number>,
) => {
	"worklet";
	if (dragArea.value === null) return;

	const yOffset = dragArea.value.startScrollOffset - scrollOffset.value;
	const startY = dragArea.value.startY + yOffset;

	const endX = event.x;
	const endY = event.y - (native ? 0 : scrollOffset.value);
	const left = Math.min(dragArea.value.startX ?? endX, endX);
	const top = Math.min(startY ?? endY, endY);
	const width = Math.abs(dragArea.value.startX - endX);
	const height = Math.abs(startY - endY);
	const proximityToTop = endY;
	const proximityToBottom = dimHeight - endY;

	dragArea.value = {
		...dragArea.value,
		endX,
		endY,
		left,
		top,
		width,
		height,
		proximityToBottom,
		proximityToTop,
	};
};
